<header class="nav" appVisualViewport [class.nav--condensed]="condensed()" [class.nav--menu]="menuOpen()">
  <div class="nav__inner container">
    <!-- The app's ONLY logo. It is laid out at hero size inside this slot and
         scaled down to dock; on the home page it flies out onto the hero at
         scroll zero. One element means it can never be in two places at once. -->
    <a routerLink="/" class="nav__brand" aria-label="Kalaburagi Sports Habba, home" #brandSlot>
      @if (logoBroken()) {
        <app-brand-mark variant="compact" />
      } @else {
        <img
          class="nav__logo"
          [class.nav__logo--stowed]="menuOpen()"
          #flyLogo
          [src]="logoSrc()"
          alt=""
          aria-hidden="true"
          (error)="logoBroken.set(true)" />
      }
    </a>

    <nav class="nav__links" aria-label="Primary">
      @for (link of links; track link.path) {
        <a
          [routerLink]="link.path"
          routerLinkActive="nav__link--active"
          [routerLinkActiveOptions]="{ exact: link.path === '/' }"
          class="nav__link">
          <span class="nav__link-label">{{ link.label }}</span>
          @if (link.path === '/live' && liveCount() > 0) {
            <span class="nav__live-count" [attr.aria-label]="liveCount() + ' matches live now'">
              <span class="live-dot"></span>{{ liveCount() }}
            </span>
          }
        </a>
      }
    </nav>

    <div class="nav__actions">
      <button
        class="nav__theme"
        type="button"
        [attr.aria-label]="isLight() ? 'Switch to dark theme' : 'Switch to light theme'"
        [title]="isLight() ? 'Switch to dark theme' : 'Switch to light theme'"
        (click)="toggleTheme()">
        @if (isLight()) {
          <!-- Moon: what you get if you press it. -->
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
          </svg>
        } @else {
          <!-- Sun -->
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </svg>
        }
      </button>

      <!-- Staff reach the login from the footer; once signed in, this is their way back. -->
      @if (isStaff()) {
        <a routerLink="/staff/dashboard" class="btn btn--ghost btn--sm nav__staff">
          <span>Dashboard</span>
        </a>
      }

      <a [href]="registerUrl" target="_blank" rel="noopener" class="btn btn--primary btn--sm nav__register">
        <span>Register Now</span>
      </a>

      <button
        class="nav__toggle"
        type="button"
        [class.nav__toggle--open]="menuOpen()"
        [attr.aria-expanded]="menuOpen()"
        aria-label="Toggle navigation menu"
        (click)="toggleMenu()">
        <span></span><span></span><span></span>
      </button>
    </div>
  </div>
</header>

<!-- Mobile drawer -->
<div class="drawer" [class.drawer--open]="menuOpen()" [attr.aria-hidden]="!menuOpen()">
  <button type="button" class="drawer__scrim" aria-label="Close menu" tabindex="-1" (click)="closeMenu()"></button>
  <nav class="drawer__panel" aria-label="Mobile">
    @for (link of links; track link.path; let i = $index) {
      <a
        [routerLink]="link.path"
        routerLinkActive="drawer__link--active"
        [routerLinkActiveOptions]="{ exact: link.path === '/' }"
        class="drawer__link"
        [style.--i]="i"
        [tabIndex]="menuOpen() ? 0 : -1">
        <span class="drawer__index">0{{ i + 1 }}</span>
        <span class="drawer__label">{{ link.label }}</span>
        @if (link.path === '/live' && liveCount() > 0) {
          <span class="drawer__live"><span class="live-dot"></span>{{ liveCount() }}</span>
        }
      </a>
    }
    <a
      [href]="registerUrl"
      target="_blank"
      rel="noopener"
      class="drawer__link drawer__link--register"
      [style.--i]="links.length"
      [tabIndex]="menuOpen() ? 0 : -1"
      (click)="closeMenu()">
      <span class="drawer__index">0{{ links.length + 1 }}</span>
      <span class="drawer__label">Register Now <span aria-hidden="true">&#8599;</span></span>
    </a>
    @if (isStaff()) {
      <a
        routerLink="/staff/dashboard"
        class="drawer__link"
        [style.--i]="links.length + 1"
        [tabIndex]="menuOpen() ? 0 : -1">
        <span class="drawer__index">0{{ links.length + 2 }}</span>
        <span class="drawer__label">Dashboard</span>
      </a>
    }
  </nav>
</div>
